<template>
  <v-app-bar app clipped-right clipped-left>
    <v-toolbar flat style="z-index: 10">
      <v-toolbar-title v-if="hasToolbarTitle">{{ $t('appTitle') }}</v-toolbar-title>
      <v-spacer class="search-spacer"></v-spacer>
      <Search ref="searchCmp"/>
      <v-spacer></v-spacer>
      <!-- menus as dropdown for mobile -->
      <v-menu
        v-model="mobileMenu"
        bottom
        offset-y
        :close-on-content-click="false">
        <template v-slot:activator="{ on, attrs }">
          <v-btn class="mr-1 hidden-md-and-up" icon v-bind="attrs" v-on="on"><v-icon>mdi-menu</v-icon></v-btn>
        </template>
        <v-card>
          <v-list>
            <v-list-item v-if="canReadUsers" :to="{name: 'users'}" exact @click="mobileMenu = !mobileMenu">
              <v-list-item-icon><v-icon>mdi-account-group</v-icon></v-list-item-icon>
              <v-list-item-title>{{ $t('users.menuTitle') }}</v-list-item-title>
            </v-list-item>
            <v-list-item v-if="canChatsRead" :to="{name: 'chats'}" @click="mobileMenu = !mobileMenu">
              <v-list-item-icon><v-icon>mdi-chat-processing</v-icon></v-list-item-icon>
              <v-list-item-title>{{ $t('chat.menuTitle') }}</v-list-item-title>
            </v-list-item>
            <v-list-item v-if="canReadQueues" :to="{name: 'queues'}" @click="mobileMenu = !mobileMenu">
              <v-list-item-icon><v-icon>mdi-human-queue</v-icon></v-list-item-icon>
              <v-list-item-title>{{ $t('queues.menuTitle') }}</v-list-item-title>
            </v-list-item>
            <v-list-item v-if="canReadConferences" :to="{name: 'conferences'}" @click="mobileMenu = !mobileMenu">
              <v-list-item-icon><v-icon>mdi-microphone-message</v-icon></v-list-item-icon>
              <v-list-item-title>{{ $t('confr.menuTitle') }}</v-list-item-title>
            </v-list-item>
            <v-list-item v-if="canUseVideoConference" :to="{name: 'video-conferences'}" @click="mobileMenu = !mobileMenu">
              <v-list-item-icon><v-icon>mdi-video</v-icon></v-list-item-icon>
              <v-list-item-title>{{ $t('videoconf.menuTitle') }}</v-list-item-title>
            </v-list-item>
            <v-list-item v-if="canReadParking" :to="{name: 'parking'}" @click="mobileMenu = !mobileMenu">
              <v-list-item-icon><v-icon>mdi-car-brake-parking</v-icon></v-list-item-icon>
              <v-list-item-title>{{ $t('parking.menuTitle') }}</v-list-item-title>
            </v-list-item>
            <v-list-item v-if="canReadVMails" :to="{name: 'voicemails'}" @click="mobileMenu = !mobileMenu">
              <v-list-item-icon><v-icon>mdi-voicemail</v-icon></v-list-item-icon>
              <v-list-item-title>{{ $t('vmail.menuTitle') }}</v-list-item-title>
            </v-list-item>
            <v-list-item v-if="canReadCdrs" :to="{name: 'cdrs'}" @click="mobileMenu = !mobileMenu">
              <v-list-item-icon><v-icon>mdi-history</v-icon></v-list-item-icon>
              <v-list-item-title>{{ $t('cdrs.menuTitle') }}</v-list-item-title>
            </v-list-item>
            <v-list-item v-if="canReadContacts || canManagePersonalContacts" :to="{name: 'contacts'}" @click="mobileMenu = !mobileMenu">
              <v-list-item-icon><v-icon>mdi-contacts</v-icon></v-list-item-icon>
              <v-list-item-title>{{ $t('contacts.menuTitle') }}</v-list-item-title>
            </v-list-item>
            <v-list-item v-if="canReadAnnounce" :to="{name: 'announcements'}" @click="mobileMenu = !mobileMenu">
              <v-list-item-icon><v-icon>mdi-bullhorn</v-icon></v-list-item-icon>
              <v-list-item-title>{{ $t('announce.menuTitle') }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-card>
      </v-menu>
      <!-- menus for desktop -->
      <v-toolbar-items class="mr-5 hidden-sm-and-down">

        <v-btn v-if="canReadUsers" icon :to="{name: 'users'}" exact
          class="toolbar-users">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon v-on="on">mdi-account-group</v-icon>
            </template>
            <span>{{ $t('users.menuTitle') }}</span>
          </v-tooltip>
        </v-btn>

        <v-btn v-if="canChatsRead" icon :to="{name: 'chats'}"
          class="toolbar-chats">
          <v-badge color="orange" :value="chatUnread">
            <span slot="badge">{{ chatUnread }}</span>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on">mdi-chat-processing</v-icon>
              </template>
              <span>Chat</span>
            </v-tooltip>
          </v-badge>
        </v-btn>

        <v-btn v-if="canReadQueues" icon :to="{name: 'queues'}" exact
          class="toolbar-queues">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon v-on="on">mdi-human-queue</v-icon>
            </template>
            <span>{{ $t('queues.menuTitle') }}</span>
          </v-tooltip>
        </v-btn>

        <v-btn v-if="canReadConferences" icon :to="{name: 'conferences'}" exact
          class="toolbar-conferences">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon v-on="on">mdi-microphone-message</v-icon>
            </template>
            <span>{{ $t('confr.menuTitle') }}</span>
          </v-tooltip>
        </v-btn>

        <v-btn v-if="canUseVideoConference" icon :to="{name: 'video-conferences'}" exact
          class="toolbar-video-conferences">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon v-on="on">mdi-video</v-icon>
            </template>
            <span>{{ $t('videoconf.menuTitle') }}</span>
          </v-tooltip>
        </v-btn>

        <v-btn v-if="canReadParking" icon :to="{name: 'parking'}"
          class="toolbar-parking">
          <v-badge :value="parkedCallsNum > 0" color="orange">
            <span slot="badge">{{ parkedCallsNum }}</span>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on">mdi-car-brake-parking</v-icon>
              </template>
              <span>{{ $t('parking.menuTitle') }}</span>
            </v-tooltip>
          </v-badge>
        </v-btn>

        <v-btn v-if="canReadVMails" icon :to="{name: 'voicemails'}"
          class="toolbar-voicemails">
          <v-badge :value="sipuaVmNum > 0" color="orange">
            <span slot="badge">{{ sipuaVmNum }}</span>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on">mdi-voicemail</v-icon>
              </template>
              <span>{{ $t('vmail.menuTitle') }}</span>
            </v-tooltip>
          </v-badge>
        </v-btn>

        <v-btn v-if="canReadCdrs" icon :to="{name: 'cdrs'}" exact
          class="toolbar-cdrs">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon v-on="on">mdi-history</v-icon>
            </template>
            <span>{{ $t('cdrs.menuTitle') }}</span>
          </v-tooltip>
        </v-btn>

        <v-btn v-if="canReadContacts || canManagePersonalContacts" icon :to="{name: 'contacts'}" exact
          class="toolbar-contacts">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon v-on="on">mdi-contacts</v-icon>
            </template>
            <span>{{ $t('contacts.menuTitle') }}</span>
          </v-tooltip>
        </v-btn>

        <v-btn v-if="canReadAnnounce" icon :to="{name: 'announcements'}" exact
          class="toolbar-announcements">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon v-on="on">mdi-bullhorn</v-icon>
            </template>
            <span>{{ $t('announce.menuTitle') }}</span>
          </v-tooltip>
        </v-btn>

      </v-toolbar-items>
      <v-toolbar-items class="mr-1">
        <CurrentUserMenu data-testid="toolbar-currentUser"/>
      </v-toolbar-items>
      <v-toolbar-items class="mr-1 mt-5">
        <SIPUAClient v-if="canUseSIPUA"/>
      </v-toolbar-items>
    </v-toolbar>
  </v-app-bar>
</template>

<script>
import CurrentUserMenu from './current_user_menu'
import Search from './search'
import SIPUAClient from './sipua_client'
import LocalStorage from 'Store/class/local_storage'
import { mapGetters } from 'vuex'

export default {
  name: 'toolbar',
  components: { SIPUAClient, CurrentUserMenu, Search },
  data () {
    return {
      mobileMenu: false
    }
  },
  mounted () {
    this.initLang()
  },
  computed: {
    ...mapGetters({
      currentUser: 'currentUser/currentUser',
      clidName: 'sipuaClidName',
      clidNum: 'sipuaClidNum',
      sipuaVmNum: 'sipuaVmNum',
      parkedCallsNum: 'parking/callsNum',
      canReadConfig: 'permissions/confRead',
      canReadSoftphone: 'permissions/softphoneRead',
      canReadUsers: 'permissions/usersRead',
      canReadQueues: 'permissions/queuesRead',
      canReadVideoConf: 'permissions/videoConfRead',
      canReadConferences: 'permissions/conferencesRead',
      canReadParking: 'permissions/parkRead',
      canReadVMails: 'permissions/vmailsRead',
      canReadCdrs: 'permissions/cdrsRead',
      canReadContacts: 'permissions/contactsRead',
      canManagePersonalContacts: 'permissions/contactsManagePersonal',
      canReadAnnounce: 'permissions/announceRead',
      canChatsRead: 'permissions/chatsRead',
      isVideoConferenceEnabled: 'videoConferenceConfig/enabled',
      chatUnread: 'chat/unread',
      searchVisible: 'search/visible',
      licenseAllowsVideoConf: 'licenses/videoConfEnabled'
    }),
    canUseSIPUA: function () {
      return this.canReadConfig && this.canReadSoftphone
    },
    hasToolbarTitle () {
      return (this.$vuetify.breakpoint.mobile && !this.searchVisible) || !this.$vuetify.breakpoint.mobile
    },
    canUseVideoConference () {
      return this.isVideoConferenceEnabled && this.canReadVideoConf && this.licenseAllowsVideoConf
    }
  },
  methods: {
    initLang () {
      const locale = LocalStorage.getLocale() || 'en'
      this.$i18n.locale = locale
      LocalStorage.setLocale(locale)
    }
  }
}
</script>

<style scoped>
.search-spacer {
  flex-grow: 0.2 !important;
}
</style>
